import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

export interface LanguageState {
    value: string
}

const initialState: LanguageState = {
    value: 'ua'
}
const localStoreKey = 'mentoring.language'
export const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        getLanguageFromStore: (state) => {
            const language = localStorage.getItem(localStoreKey);
            if (language) state.value = language;
        },
        setLanguage: (state, action: PayloadAction<string>) => {
            state.value = action.payload
            localStorage.setItem(localStoreKey, JSON.stringify({language: state.value}))
        }
    }
})

export const {
    setLanguage,
    getLanguageFromStore
} = languageSlice.actions

export default languageSlice.reducer
